import { useMemo } from "react";
import { isBefore, parseISO, startOfToday } from "date-fns";
import { useSession } from "../api/helpers";

const useIsFinished = (sessionId: number) => {
  const session = useSession(sessionId);
  return useMemo(
    () =>
      session?.status !== "InProgress" &&
      (session?.status === "Finished" ||
        (session?.endTime &&
          isBefore(parseISO(session.endTime), startOfToday()))),
    [session?.endTime, session?.status],
  );
};

export default useIsFinished;
